import { useEffect, useState } from "react";
import { ALL_CATEGORIES } from "../../../../integrations/dashboard/hooks/useLoadPaginatedIntegrations";
import EmptyStateWrapper from "../../../../shared/layout/EmptyStateWrapper";
import MergeTable from "../../../../shared/MergeTable";
import useAutomatedModifiedAtFilters from "../../hooks/useAutomatedModifiedAtFilters";
import { AutomatedModifiedAtFilterDetails } from "../../types";
import AutomatedModifiedAtFiltersTableContent from "./AutomatedModifiedAtFiltersTableContent";
import AutomatedModifiedAtFiltersTableHeader from "./AutomatedModifiedAtFiltersTableHeader";
import { APICategory } from "@merge-api/merge-javascript-shared";

interface AutomatedModifiedAtFiltersTableProps {
  integrationID: string;
}

const TABLE_HEADER_COLUMNS = [
  "Model",
  "Category",
  "Blueprints",
  "LinkedAccountConditions",
  "Existing filters",
];

const AutomatedModifiedAtFiltersTable = ({
  integrationID,
}: AutomatedModifiedAtFiltersTableProps) => {
  const [category, setCategory] = useState<APICategory | "all">(ALL_CATEGORIES);
  const [amfModelsDetailsToDisplay, setAmfModelsDetailsToDisplay] = useState<
    AutomatedModifiedAtFilterDetails[]
  >([]);

  const {
    isLoadingFilters,
    loadAllAutomatedModifiedAtFilters,
    amfModelsDetails,
  } = useAutomatedModifiedAtFilters(integrationID);

  useEffect(() => {
    loadAllAutomatedModifiedAtFilters();
  }, []);

  useEffect(() => {
    if (category === "all") {
      setAmfModelsDetailsToDisplay(amfModelsDetails);
      return;
    }
    setAmfModelsDetailsToDisplay(
      amfModelsDetails.filter((amfModelDetails) => amfModelDetails.amf_model.category === category)
    );
  }, [category, amfModelsDetails]);

  if (isLoadingFilters) {
    return <EmptyStateWrapper isSpinner />;
  }

  return (
    <div>
      {amfModelsDetails.length > 0 && (
        <AutomatedModifiedAtFiltersTableHeader
          className="mb-6"
          setCategory={setCategory}
          category={category}
        />
      )}
      <MergeTable
        hover={false}
        hasMarginBottom={false}
        hasMorePaddingOnFirstElement
        className="mb-6"
        header={
          <>
            {TABLE_HEADER_COLUMNS.map((header) => (
              <th key={header} scope="col">
                {header}
              </th>
            ))}
          </>
        }
        content={
          <AutomatedModifiedAtFiltersTableContent
            integrationID={integrationID}
            filteredAmfDetails={amfModelsDetailsToDisplay}
            amfDetails={amfModelsDetails}
            numTableColumns={TABLE_HEADER_COLUMNS.length}
          />
        }
      />
    </div>
  );
};

export default AutomatedModifiedAtFiltersTable;
